import { domReady } from "./utils/domready"
import PerfectScrollbar from 'perfect-scrollbar';
import MMenu from './components/mmenu'



class App {

    static start() {
        return new App()
    }

    constructor() {
        Promise
            .all([
                domReady()
            ])
            .then(
                this.init.bind(this)
            )
    }



    init() {
        console.info('🚀App:init')

         // MM menu
         MMenu()

        let scrollbar = document.querySelector('.js-scrollbox')

        if (scrollbar) {
            const ps = new PerfectScrollbar('.js-scrollbox', {
                suppressScrollY: true
                // wheelSpeed: 2,
                // wheelPropagation: true,
                // minScrollbarLength: 20
            });
 
            window.addEventListener('resize', () => { 
                ps.update()
            });
        }

    }

}

App.start()